import { Box, Button } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  isFirstStep: boolean;
  isLastStep: boolean;
  isDirty: boolean;
  isSubmitting: boolean;
  formId: string;
  onPrevious: () => void;
  onAdvance: () => void;
  onSaveOnly: () => void;
};

export const StepNavigation = ({
  isFirstStep,
  isLastStep,
  isDirty,
  isSubmitting,
  formId,
  onPrevious,
  onAdvance,
  onSaveOnly,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      {!isFirstStep && (
        <Button startIcon={<KeyboardArrowLeft />} onClick={onPrevious}>
          {t(RESOURCES.PreviousStepButton)}
        </Button>
      )}
      <Box display="flex" gap={2} ml="auto">
        <Button disabled={!isDirty || isSubmitting} onClick={onSaveOnly}>
          {t(isLastStep ? RESOURCES.SaveButton : RESOURCES.SaveChangesButton)}
        </Button>
        {!isLastStep && (
          <Button
            variant="contained"
            endIcon={<KeyboardArrowRight />}
            type={isDirty ? "submit" : "button"}
            form={isDirty ? formId : undefined}
            onClick={isDirty ? undefined : onAdvance}
          >
            {t(RESOURCES.NextStepButton)}
          </Button>
        )}
      </Box>
    </Box>
  );
};
